import { render, staticRenderFns } from "./tableHeader.vue?vue&type=template&id=1e60fbc4"
import script from "./tableHeader.vue?vue&type=script&lang=ts"
export * from "./tableHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports